export const initialState = {
  fromdb: null,
  terminalDetail: [],
  tablePages: 0,
  isLoading: false,
  successModal: {
    show: false,
    message: null,
  },
  errorModal: {
    show: false,
    message: null,
  },
  error: null,
};
